import {
  TButtonTranslations,
} from './npm-controller-menu.ts';

const buttonTranslations: TButtonTranslations = {
  LOAD_JOB: {
    label: 'Załaduj zadanie',
    confirmMessage: '',
    confirmHeader: '',
    confirmLabel: '',
  },
  START_JOB: {
    label: 'Rozpocznij pracę',
    confirmMessage: 'Zadanie rozpocznie się natychmiast.',
    confirmHeader: 'Rozpocząć {recipeCode} na {assetDisplayName}?',
    confirmLabel: 'Rozpocznij {recipeCode}',
  },
  ABORT_JOB: {
    label: 'Przerwij zadanie',
    confirmMessage: 'Uruchomione zadanie zostanie natychmiast zatrzymane.',
    confirmHeader: 'Przerwać zadanie {jobNo} ({recipeCode}) na {assetDisplayName}?',
    confirmLabel: 'Przerwij {jobNo}',
  },
  RESUME_JOB: {
    label: 'Wznów pracę',
    confirmMessage: 'Zadanie będzie kontynuowane od miejsca zatrzymania.',
    confirmHeader: 'Wznowić {recipeCode} na {assetDisplayName}?',
    confirmLabel: 'Wznów {recipeCode}',
  },
};

export default {
  button: buttonTranslations,
};
